import { _ as _object_spread } from "@swc/helpers/_/_object_spread";
import { getGlobalProperty } from "@faire/web--source/common/globals/getGlobalProperty";
import { logError } from "@faire/web--source/common/logging";
export var googleTagManagerInterceptor = function(params) {
    if (params.facebookPixelEvent) {
        try {
            emitGoogleTagManagerEvent(params.facebookPixelEvent, params.pixelCustomDataParams, {
                eventID: params.eventId
            });
        } catch (_) {
        /* ignore */ }
    }
};
export var emitGoogleTagManagerEvent = function(event, vars, context) {
    var _vars_contents;
    var dataLayer = getGlobalProperty("dataLayer");
    if (!dataLayer) {
        if (getGlobalProperty("envName") === "production") {
            logError("dataLayer not initialized");
        }
        return;
    }
    var contents = vars === null || vars === void 0 ? void 0 : (_vars_contents = vars.contents) === null || _vars_contents === void 0 ? void 0 : _vars_contents.map(function(content) {
        return {
            contentId: content.id,
            price: content.item_price,
            quantity: content.quantity
        };
    });
    var _vars_cart_value;
    var data = {
        value: (_vars_cart_value = vars === null || vars === void 0 ? void 0 : vars.cart_value) !== null && _vars_cart_value !== void 0 ? _vars_cart_value : vars === null || vars === void 0 ? void 0 : vars.value,
        currency: vars === null || vars === void 0 ? void 0 : vars.currency,
        conversionId: context.eventID,
        contents: contents
    };
    dataLayer.push(_object_spread({
        event: event
    }, data));
};
